

<style>
  .actionBox {
      border:1px solid #dddddd; border-radius:12px; background-color: #ffffff;
  }
  .actionBox > div:first-child {
      width:100%; border-bottom:1px solid #dddddd;
  }
  .actionBox > div:first-child>div {
      padding:14px 20px 14px 20px; text-align: center;
  }
  .actionBox > div:nth-child(2) {
      width:100%; padding-bottom:15px;
  }
  .actionBox > div:nth-child(2)>div {
      padding:15px 15px 0px 15px;
  }

  .actionBox h2 {
      margin:0px; padding:0px;
  }

</style>
<div style="width: 400px; margin: 0 auto;">
    <input type="button" class="btn-core" value="Suite Sign-in" style="width:100%;" id="btnBootstrapSession" (click)="btnSuiteLogin_click()"/>
</div>
<!-- <div style="width: 50%; max-width: 400px; margin:0% auto;">

  <div class="actionBox signinBox" style="width:100%;" [hidden]="requiresPasswordReset || requires2FA || forgotPassword" [showLoadingSpinner]="isLoading">

      <div>
          <div>
              <h1>Sign In</h1>
          </div>
      </div>

      <div>
          <div>

              <form  #triggerForm="ngForm"  (keydown.enter)="triggerSubmit()" (ngSubmit)="btnSigninClick()">
                  <div class="row">
                      <div class="col">
                          <app-text-input [type]="TextModes.Email" [name]="'txtEmail'" [showDefaultValue]="false" [(ngModel)]="this.data.email" [label]="'Email'" id="txtEmail" [testId]="'username'"></app-text-input>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col">
                          <app-text-input [type]="TextModes.Password" [name]="'txtPassword'" [showDefaultValue]="false" [(ngModel)]="this.data.password" [label]="'Password'" [testId]="'password'"></app-text-input>
                      </div>
                  </div>
              </form>

          </div>
          
          <div style="text-align: center; padding-bottom:10px;">
              <input type="submit" class="button_primary button_var_2" value="Sign in" style="margin-right:4%; width:48%;" id="btnLogin" (click)="btnSigninClick()" (keydown.enter)="btnSigninClick()" />
              <input type="button" class="button_primary button_var_2" value="Forgot password" style="width:48%;" id="btnForgotPassword" [disabled]="sentForgotPasswordEmail" (click)="btnForgotPassword_click()" (keydown.enter)="btnForgotPassword_click()" />
          </div>
      
      </div>

  </div>


  <div class="actionBox signinBox" style="padding:10px;">
      <input type="button" class="button_primary button_var_2" value="Suite Sign-in" style="width:100%;" id="btnBootstrapSession" (click)="btnSuiteLogin_click()" />
  </div>

  <div class="actionBox signinBox" [hidden]="!forgotPassword">
      <div>
          <div>
              <h1>Forgot password</h1>
          </div>
      
      </div>

      <div>
          <div class="row">
              <p>Enter your email address and we'll send a link to reset your password.</p>

              <div class="col">
                  <app-text-input [type]="TextModes.Email" [name]="'txtEmail'" [(ngModel)]="this.data.email" [showDefaultValue]="false" [label]="'Email'" id="txtEmail" [testId]="'username'"></app-text-input>
              </div>
          </div>

          <div style="text-align: center; padding-bottom:10px;">
              <input type="button" id="btnCancelForgotPassword" class="button_primary button_var_2" value="Cancel"  style="margin-right:4%; width:48%;" (click)="btnCancel_click()" />
              <input type="button" id="btnSendForgotPassword" class="button_primary button_var_2" value="Reset my password" style="width:48%;" (click)="btnSendForgotPassword_click()" (keydown.enter)="btnSendForgotPassword_click()" />
          </div>
      </div>

  </div>


  <div class="actionBox signinBox width-constrained-some" [hidden]="!requires2FA">
      <div>
          <div>
              <h1>2-Factor Authentication</h1>
          </div>
      
      </div>

      <div>
          <div class="row">
              <p>Enter the 2-factor authentication code that was sent to your email address:</p>
              <app-text-input [type]="TextModes.Numeric" [minLength]="6" [maxLength]="6" [showDefaultValue]="false" [(ngModel)]="tfaChars" [label]="'6-digit code'" (keyup)="enter2fa_keyup($event)"></app-text-input>
          </div>
      </div>

  </div>

  <div class="actionBox signinBox" [hidden]="!requiresPasswordReset">

      <div>
          <div>
              <h1>Choose a new password</h1>
          </div>
      </div>

      <div>
          <div>
              <div style="margin-bottom:20px;">

                  <div class="row">
                      <div class="col">
                          Please ensure that your new password is at least 12 characters long and is not the same as any of your
                          previous 5 passwords.
                      </div>
                  </div>

                  <div class="row">
                      <div class="col">
                          {{data.email}}
                      </div>
                  </div>

                  <div class="row" style="margin-bottom:20px;" [hidden]="resetCode != null && resetCode != ''">
                      <div class="col">
                          <app-text-input [type]="TextModes.Password" [name]="'txtPassword'" [showDefaultValue]="false" [(ngModel)]="this.data.password" [label]="'Current Password'"></app-text-input>
                      </div>
                  </div>


                  <div class="row">
                      <div class="col">
                          <app-text-input [type]="TextModes.Password" [name]="'txtPassword'" [showDefaultValue]="false" [(ngModel)]="this.data.newPassword" [label]="'New Password'"></app-text-input>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col">
                          <app-text-input [type]="TextModes.Password" [name]="'txtPassword'" [showDefaultValue]="false" [(ngModel)]="this.data.newPassword2" [label]="'Confirm Password'"></app-text-input>
                      </div>
                  </div>

              </div>
              
              <input type="submit" id="btnReset" value="Submit" type="button" class="button_primary button_var_2" style="width:100%;" (click)="btnResetPassword_click()" />
          
          </div>
      </div>

  </div>
</div> -->
